import React, { Component } from 'react';

class WorkExprience extends Component {
  
  render() {
    const workExperience = (
    <section id="work-experience" className="resume-section">
    <article className="container">
    <div className="row">
        <div className="category-title col-md-12">
        <div className="row">
            <div className="col-md-4">
            <h2>Work Experience</h2>
            </div>
        </div>
        </div>
        <div className="card-container">
        <span className="col-md-3 col-md-offset-1 side-note">June 2013 – April 2017</span>
        <div className="col-md-6 resume-card">
            <h3 className="title">Software Developer<small>@ GraceKennedy Money Services Ltd</small></h3>
            <p>Developed direct customer payout application that interface with western union international applications. <br />Worked on 9 different projects in three years; writing full web, desktop GUI applications, windows services and various core className libraries. <br />Lead initiatives to standardize banking formats for all automated transfer systems. <br/>Participated in initiatives for improving user experience across products (through team sessions, peer reviews).</p>
        </div>
        </div>
        <div className="card-container">
        <span className="col-md-3 col-md-offset-1 side-note">December 2011 – June 2013</span>
        <div className="col-md-6 resume-card">
            <h3 className="title">Junior Software Developer<small>@ GraceKennedy Money Services Ltd</small></h3>
            <p>Developed direct customer payout application that interface with western union international applications. <br />Worked on 5 different projects in three years; writing full web, desktop GUI applications, windows services and various core className libraries</p>
        </div>
        </div>
        <div className="card-container">
        <span className="col-md-3 col-md-offset-1 side-note">March 2014 - May 2014</span>
        <div className="col-md-6 resume-card">
            <h3 className="title">Laravel Developer<small>@ Choices Business Solution</small></h3>
            <p>Conceptualized and implemented features across all parts of the product.</p><p>Conceptualized re-engaging strategy for uncompleted student accounts </p><p>Plan and execute the conversion of a then paper based system to a robust and responsive web application build on Laravel 4.</p>
        </div>
        </div>
    </div>
    </article>
    </section>
    );
    return (
         workExperience
    );
  }
  
}

export default WorkExprience;



// WEBPACK FOOTER //
// ./src/components/resume-components/work-experience.js